import { render } from "./payment-form.vue?vue&type=template&id=d1222cf6&scoped=true"
import script from "./payment-form.vue?vue&type=script&lang=js"
export * from "./payment-form.vue?vue&type=script&lang=js"

import "./payment-form.vue?vue&type=style&index=0&id=d1222cf6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1222cf6"]])

export default __exports__